import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineMegaphoneIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.9912 2.002a.9998.9998 0 0 0-.924.6172.9995.9995 0 0 0-.076.3828v.6367a9.0362 9.0362 0 0 1-7 3.3633h-6a3.0033 3.0033 0 0 0-3 3v2a3.0035 3.0035 0 0 0 3 3h.4838l-2.4027 5.6064a.9996.9996 0 0 0 .4448 1.2743.9996.9996 0 0 0 .4741.1193h4a.9989.9989 0 0 0 .919-.6064l2.7237-6.3556a9.0282 9.0282 0 0 1 6.3573 3.3251v.6369a1.0001 1.0001 0 0 0 2 0v-16a.9985.9985 0 0 0-.6172-.924.9996.9996 0 0 0-.3828-.076Zm-14 11a1.0008 1.0008 0 0 1-1-1v-2a1.0007 1.0007 0 0 1 1-1h1v4h-1Zm2.3408 7H6.5078l2.1426-5h1.8242l-2.1426 5Zm10.6592-4.4782a11.0515 11.0515 0 0 0-7-2.5218h-3v-4h3a11.0528 11.0528 0 0 0 7-2.5224v9.0442Z"/>
  </SvgIcon>
}

export default LineMegaphoneIcon
